export const environment = {
    production: false,
    staging: true,

    api: 'https://test.api.staff.asvz.ch/api',
    idpApi: 'https://test.api.id.asvz.ch/api',

    identity: {
        client_id: '343919110838638906', // StaffTool-Admin-Web-TEST
        authority: 'https://test.idp.asvz.ch',
        redirect_uri: 'https://test.admin.staff.asvz.ch/assets/oidc-login-redirect.html',
        scope: 'openid profile stage.staff-api stage.tn-auth',
        response_type: 'id_token token',
        post_logout_redirect_uri: 'https://test.admin.staff.asvz.ch/?postLogout=true',
        silent_redirect_uri: 'https://test.admin.staff.asvz.ch/assets/silent-redirect.html',
        logoutUrl: 'https://test.id.asvz.ch/logout',
        postLogoutRedirectUri: 'https://test.admin.staff.asvz.ch/logout-complete',
    },

    // impersonation for staff tool 
    impersonation: {
        startUrl: "https://test.staff.asvz.ch/admin/impersonation/start?id="
    },

    baseUrl: 'https://test.admin.staff.asvz.ch',
    staffToolUrl: 'https://test.staff.asvz.ch',
    onlineDeskUrl: 'https://test.schalter.asvz.ch/tn',
    webPlannerUrl: 'https://test.webplanner.asvz.ch',
    hangfireUrl: "https://test.hangfire.staff.asvz.ch/dashboard",
    testMailsUrl: "http://test.schalter.asvz.ch:37408"
};
